import ComboBoxItem from "components/ComboBox/ComboBoxItem";

const INDUSTRIES: ComboBoxItem<string>[] = [
  { id: 0, label: "Healthcare", value: "Healthcare" },
  { id: 1, label: "Finance/Fintech", value: "Finance/Fintech" },
  { id: 2, label: "Retail/E-commerce", value: "Retail/E-commerce" },
  {
    id: 3,
    label: "Technology/Software Development",
    value: "Technology/Software Development",
  },
  { id: 4, label: "Education/E-learning", value: "Education/E-learning" },
  {
    id: 5,
    label: "Transportation/Logistics",
    value: "Transportation/Logistics",
  },
  {
    id: 6,
    label: "Real Estate/Property Management",
    value: "Real Estate/Property Management",
  },
  { id: 7, label: "Hospitality/Travel", value: "Hospitality/Travel" },
  { id: 8, label: "Manufacturing", value: "Manufacturing" },
  {
    id: 9,
    label: "Agriculture/Food Technology",
    value: "Agriculture/Food Technology",
  },
  { id: 10, label: "Media/Entertainment", value: "Media/Entertainment" },
  { id: 11, label: "Gaming", value: "Gaming" },
  {
    id: 12,
    label: "Energy/Renewable Resources",
    value: "Energy/Renewable Resources",
  },
  { id: 13, label: "Telecommunications", value: "Telecommunications" },
  {
    id: 14,
    label: "Non-Profit/Social Impact",
    value: "Non-Profit/Social Impact",
  },
  { id: 15, label: "Automotive", value: "Automotive" },
  { id: 16, label: "Legal/Compliance", value: "Legal/Compliance" },
  {
    id: 17,
    label: "Human Resources/Recruitment",
    value: "Human Resources/Recruitment",
  },
  { id: 18, label: "Marketing/Advertising", value: "Marketing/Advertising" },
  {
    id: 19,
    label: "Government/Public Sector",
    value: "Government/Public Sector",
  },
  { id: 20, label: "Insurance", value: "Insurance" },
  {
    id: 21,
    label: "Biotechnology/Pharmaceuticals",
    value: "Biotechnology/Pharmaceuticals",
  },
  {
    id: 22,
    label: "Construction/Engineering",
    value: "Construction/Engineering",
  },
  { id: 23, label: "Fashion/Apparel", value: "Fashion/Apparel" },
  { id: 24, label: "Environmental Services", value: "Environmental Services" },
  { id: 25, label: "Cybersecurity", value: "Cybersecurity" },
  { id: 26, label: "Consumer Goods/FMCG", value: "Consumer Goods/FMCG" },
  {
    id: 27,
    label: "Art/Culture/Creative Services",
    value: "Art/Culture/Creative Services",
  },
  { id: 28, label: "Space/Aerospace", value: "Space/Aerospace" },
  { id: 29, label: "Sports/Fitness", value: "Sports/Fitness" },
  { id: 30, label: "Others", value: "Others" },
];

export default INDUSTRIES;
